import { ProductSaleFlow } from "@expert/sales-tools";
import { Flex } from "@mantine/core";
import { ErrorBoundary } from "react-error-boundary";

import { RenderError } from "@/shared-utils";

export function ProductSaleFlowPanel() {
    return (
        <Flex pos={"absolute"} inset={0} bg="dark.7">
            <ErrorBoundary fallback={<RenderError />}>
                <ProductSaleFlow />
            </ErrorBoundary>
        </Flex>
    );
}
